export const retentionSteps = [
  {
    id: 'step1',
    title: 'Step 1: Navigate to Retention Bonus',
    page: 'Retention Bonus',
    content: [
      'Click "Retention Bonus" in the sidebar navigation.',
      'The page displays the half-yearly retention bonus payout management interface.',
      'You will see the filter bar, KPI summary cards, and the payout table.',
    ],
    note: 'Only employees with a Retention Amount greater than 0 (set in the Employee profile under Salary & Bonus) are eligible for payouts.',
  },
  {
    id: 'step2',
    title: 'Step 2: Select the Payout Period',
    page: 'Retention Bonus',
    content: [
      'Use the Period dropdown in the filter bar to select the half-year cycle.',
      'Retention bonuses are paid in two fixed cycles each year.',
      'If payouts have already been generated for the selected period, they will load automatically.',
    ],
    details: [
      { label: 'Apr — Sep', desc: 'Covers April through September of a given year.' },
      { label: 'Oct — Mar', desc: 'Covers October through March of the following year.' },
    ],
    note: 'Always verify you have selected the correct period before generating payouts.',
  },
  {
    id: 'step3',
    title: 'Step 3: Generate Payouts',
    page: 'Retention Bonus',
    content: [
      'Click the "Generate Payouts" button (top-right corner).',
      'The system will create a payout record for every active employee with retention > 0.',
      'Each record auto-calculates: Monthly Retention x Eligible Months = Total Payout.',
      'Employees who joined mid-period will be automatically pro-rated (fewer months).',
    ],
    details: [
      { label: 'Pro-rating', desc: 'If an employee joined after the period start month, only months from joining onward are counted. A "Pro-rated" badge is shown next to the month count.' },
      { label: 'Duplicates', desc: 'If payouts already exist for an employee in the same period, they will not be duplicated — the system skips them.' },
    ],
    important: 'Only Admin and Super Admin roles can generate payouts.',
  },
  {
    id: 'step4',
    title: 'Step 4: Review & Edit Amounts',
    page: 'Retention Bonus',
    content: [
      'After generation, all employees appear in the payout table with editable Total Payout fields.',
      'Review each row: Employee, Organization, Monthly Retention, Months, and Total Payout.',
      'To override the auto-calculated amount, simply type a new value in the Total Payout input field.',
      'The amount saves automatically when you click away from the field.',
    ],
    details: [
      { label: 'Editable', desc: 'The Total Payout field is editable for ALL unfinalised rows — both pro-rated and non-pro-rated employees.' },
      { label: 'Locked', desc: 'Once a row is finalized, the amount is locked and displayed in green. Only Super Admin can revert it to make it editable again.' },
    ],
    note: 'Use the Search, Organization, Status, and Sort filters to quickly find specific employees.',
  },
  {
    id: 'step5',
    title: 'Step 5: Finalize Payouts',
    page: 'Retention Bonus',
    content: [
      'Check the "Finalized" checkbox on each row to lock the amount and confirm it for payment.',
      'Alternatively, click "Finalize All Pending" in the bottom action bar to finalize all remaining rows at once.',
      'Finalized rows show a blue "FINALIZED" status pill and the amount becomes read-only.',
    ],
    important: 'Finalization locks the amount. Double-check figures before finalizing. Only Super Admin can revert a finalized record.',
  },
  {
    id: 'step6',
    title: 'Step 6: Mark as Paid',
    page: 'Retention Bonus',
    content: [
      'After finalizing, the "Paid" checkbox becomes enabled for that row.',
      'Check the "Paid" checkbox once the actual bank transfer is completed.',
      'Alternatively, click "Mark All Paid" to mark all finalized rows as paid at once.',
      'Paid rows show a green "PAID" status pill with a green-tinted background.',
    ],
    note: 'The Paid checkbox can only be checked after finalization. The KPI cards update in real-time to reflect payment progress.',
  },
  {
    id: 'step7',
    title: 'Step 7: Revert (Super Admin Only)',
    page: 'Retention Bonus',
    content: [
      'If a mistake was made, Super Admin can revert a finalized or paid record back to Pending status.',
      'Click the revert icon (circular arrow) on the specific row, or click "Revert All" in the action bar.',
      'Reverting re-opens the Total Payout field for editing and unchecks Finalized and Paid.',
    ],
    important: 'Only the Super Admin role has access to revert actions. Admin and other roles cannot see or use revert buttons.',
  },
  {
    id: 'step8',
    title: 'Step 8: Export Report',
    page: 'Retention Bonus',
    content: [
      'Click "Export CSV" in the bottom-right of the action bar.',
      'A CSV file downloads with all visible payout data including Employee, Monthly Retention, Months, Total Payout, and Status.',
      'Use filters before exporting to get a specific subset (e.g., only Paid, or only a specific Organization).',
    ],
    note: 'The export respects all active filters — only the displayed rows are included in the CSV.',
  },
];
